import { FieldErrors, useFieldContext } from '../';
import { Label, RangeSliderV2 } from '../../Elements';

type RangeSliderFieldProps = {
	label?: string | React.ReactElement;
	additionalInfo?: string | React.ReactElement;
	max: number;
	min: number;
	surfaceError?: boolean; // whether to set invalid form values
};

export const RangeSliderField = ({
	label,
	additionalInfo,
	max,
	min,
	surfaceError,
}: RangeSliderFieldProps) => {
	const field = useFieldContext<[number, number]>();

	// hide the error messages until the field has been touched
	const hideErrors = !field.state.meta.isTouched;

	return (
		<div className='flex flex-col'>
			<Label htmlFor={field.name} label={label} additionalInfo={additionalInfo} />
			<RangeSliderV2
				name={field.name}
				min={min}
				max={max}
				fieldValue={field.state.value}
				initialValue={field.state.value}
				handleChange={field.handleChange}
				surfaceError={surfaceError}
			/>
			<FieldErrors meta={field.state.meta} name={field.name} hideErrors={hideErrors} />
		</div>
	);
};
